import React from "react";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import CloseIcon from "@mui/icons-material/Close";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";

import Attachments from "./Attachments";

export default function AttachmentModal({ inventoryRequestId, onClose }) {
  return (
    <Dialog open fullWidth maxWidth="md" onClose={onClose}>
      <DialogTitle sx={{ position: "relative" }}>
        <Typography variant="h2" color="textPrimary" align="center">
          Attachments
        </Typography>
        <IconButton
          color="textPrimary"
          sx={{ position: "absolute", right: 0, top: 0 }}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Attachments entityId={inventoryRequestId} entityType="inventoryRequest" />
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}
